export default __webpack_public_path__ + "static/media/Roboto-Bold.e0f6ebad.ttf";